/* ===== Add-ons: selected styling for the filter-plan/accessory checkboxes + bottom "Pair it with" pop-up ===== */
document.addEventListener('change',(e)=>{
  const c=e.target.closest('[data-addon-check]');
  if(!c)return;
  const wrap=c.closest('[data-plan-option],[data-addon-row]');
  if(wrap)wrap.classList.toggle('is-selected',c.checked);
});
(function(){
  const pop=document.querySelector('[data-addon-popup]');
  if(!pop)return;
  let dismissed=false;
  try{dismissed=sessionStorage.getItem('fiipyAddonPopup')==='1';}catch(e){}
  const buyBox=document.querySelector('.offer__actions')||document.querySelector('[data-buy-box]');
  function onScroll(){
    if(dismissed)return;
    const past=buyBox?buyBox.getBoundingClientRect().bottom<0:window.scrollY>1200;
    const nearEnd=window.scrollY+window.innerHeight>document.documentElement.scrollHeight-400;
    pop.classList.toggle('is-visible',past&&!nearEnd);
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
  function dismiss(){dismissed=true;pop.classList.remove('is-visible');try{sessionStorage.setItem('fiipyAddonPopup','1');}catch(e){}}
  document.addEventListener('click',(e)=>{
    if(e.target.closest('[data-addon-popup-close]')){dismiss();return;}
    if(e.target.closest('[data-addon-popup] [data-addon-add]'))dismiss();
  });
})();

/* ===== Add-ons: colour dots, quantity stepper, "+ Add" toggle, free-shipping meter, Add button ===== */
function addonShipMeter(){
  const box=document.querySelector('[data-addons]');
  if(!box)return;
  const kit=Number(box.dataset.kitPrice)||0, goal=Number(box.dataset.threshold)||7500;
  let extra=0;
  box.querySelectorAll('[data-addon-row][data-mode="check"]').forEach(r=>{
    const q=parseInt(r.querySelector('[data-qty-val]').textContent,10)||0;
    extra+=q*(Number(r.dataset.price)||0);
  });
  const total=kit+extra, left=goal-total;
  const meter=box.querySelector('[data-ship-meter]');
  box.querySelector('[data-ship-bar]').style.width=Math.min(100,Math.round(total/goal*100))+'%';
  meter.classList.toggle('is-unlocked',left<=0);
  box.querySelector('[data-ship-text]').innerHTML=left<=0
    ?'🎉 You\'ve unlocked <strong>FREE shipping</strong>'
    :'You\'re <strong>$'+(left/100).toFixed(2)+'</strong> away from <strong>FREE shipping</strong>';
}
document.addEventListener('DOMContentLoaded',addonShipMeter);
document.addEventListener('click',(e)=>{
  const sw=e.target.closest('[data-swatch]');
  if(sw){
    if(sw.disabled)return;
    const row=sw.closest('[data-addon-row]');
    if(!row)return;
    row.querySelectorAll('[data-swatch]').forEach(x=>x.classList.remove('is-selected'));
    sw.classList.add('is-selected');
    row.dataset.variantId=sw.dataset.variantId;
    if(row.dataset.mode==='cart'){const m={};(row.dataset.qmap||'').split(',').forEach(x=>{const p=x.split(':');if(p[0])m[p[0]]=+p[1];});const qv=row.querySelector('[data-qty-val]');if(qv)qv.textContent=m[sw.dataset.variantId]||0;}
    row.style.setProperty('--tint',sw.style.getPropertyValue('--sw'));
    const pic=row.querySelector('[data-addon-img]');
    if(pic&&sw.dataset.image)pic.src=sw.dataset.image;
    const nm=row.querySelector('[data-swatch-name]');
    if(nm&&sw.dataset.name)nm.textContent=sw.dataset.name;
    return;
  }
  const tog=e.target.closest('[data-addon-toggle]');
  if(tog){
    const row=tog.closest('[data-addon-row]');
    row.querySelector('[data-qty-val]').textContent='1';
    row.classList.add('is-selected');
    addonShipMeter();
    return;
  }
  const step=e.target.closest('[data-qty-plus],[data-qty-minus]');
  if(step&&step.closest('[data-addon-row][data-mode="cart"]')){
    const row=step.closest('[data-addon-row]');
    if(row.dataset.busy)return;
    const id=row.dataset.variantId;
    const val=row.querySelector('[data-qty-val]');
    const cur=parseInt(val.textContent,10)||0;
    const next=Math.max(0,Math.min(10,cur+(step.hasAttribute('data-qty-plus')?1:-1)));
    if(next===cur||!id)return;
    row.dataset.busy='1';
    val.textContent=next;
    const req=cur===0
      ?fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(id),quantity:1})})
      :fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:String(id),quantity:next})});
    req.then(r=>r.json()).then(()=>{
      const drawer=document.querySelector('cart-drawer');
      return drawer?drawer.refresh():null;
    }).catch(()=>{}).finally(()=>{delete row.dataset.busy;});
    return;
  }
  if(step&&step.closest('[data-addon-row]')){
    const row=step.closest('[data-addon-row]');
    const val=row.querySelector('[data-qty-val]');
    const min=row.dataset.mode==='check'?0:1;
    let q=parseInt(val.textContent,10)||0;
    q=Math.max(min,Math.min(10,q+(step.hasAttribute('data-qty-plus')?1:-1)));
    val.textContent=q;
    row.classList.toggle('is-selected',row.dataset.mode==='check'&&q>0);
    addonShipMeter();
    return;
  }
  const add=e.target.closest('[data-addon-add]');
  if(add){
    const row=add.closest('[data-addon-row]');
    const id=row&&row.dataset.variantId;
    if(!id)return;
    const qty=parseInt(row.querySelector('[data-qty-val]').textContent,10)||1;
    add.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(id),quantity:qty})})
      .then(r=>r.json()).then(()=>{
        const drawer=document.querySelector('cart-drawer');
        if(drawer){drawer.refresh().then(()=>drawer.open());}
      }).catch(()=>{}).finally(()=>{add.disabled=false;});
  }
});

/* ===== Kit card: quantity stepper next to Add to Cart / Buy it now ===== */
document.addEventListener('click',(e)=>{
  const b=e.target.closest('[data-kit-plus],[data-kit-minus]');
  if(!b)return;
  const v=b.closest('[data-kit-qty]').querySelector('[data-kit-qty-val]');
  let q=parseInt(v.textContent,10)||1;
  q=Math.max(1,Math.min(10,q+(b.hasAttribute('data-kit-plus')?1:-1)));
  v.textContent=q;
  const inp=document.querySelector('[data-bundle-qty-input]');
  if(inp)inp.value=q;
});

/* ===== Filter Plan card: its own Add to Cart ===== */
document.addEventListener('click',(e)=>{
  const btn=e.target.closest('[data-plan-add]');
  if(!btn)return;
  const card=btn.closest('[data-plan-option]');
  const id=card&&card.dataset.variantId;
  if(!id)return;
  const item={id:Number(id),quantity:1};
  if(card.dataset.sellingPlan)item.selling_plan=Number(card.dataset.sellingPlan);
  btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(item)})
    .then(r=>r.json()).then(()=>{
      const drawer=document.querySelector('cart-drawer');
      if(drawer){drawer.refresh().then(()=>drawer.open());}
    }).catch(()=>{}).finally(()=>{btn.disabled=false;});
});
